/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Tab_PortalsInputs */

const cs_property_tab_portals = /** @type {(inputs: Property_Tab_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portály`)
};

const en_property_tab_portals = /** @type {(inputs: Property_Tab_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portals`)
};

/**
* | output |
* | --- |
* | "Portals" |
*
* @param {Property_Tab_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tab_portals = /** @type {((inputs?: Property_Tab_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Tab_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tab_portals(inputs)
	return cs_property_tab_portals(inputs)
});